import { getPurinaOrgId } from "./utils.mjs";
const getAwsSettings = (cognitoConfig)=>{
    const auth = {
        Cognito: {
            userPoolId: cognitoConfig.userPoolId,
            userPoolClientId: cognitoConfig.userPoolWebClientId,
            signUpVerificationMethod: cognitoConfig.signUpVerificationMethod || 'link',
            loginWith: {
                oauth: {
                    domain: cognitoConfig.oauth.domain,
                    scopes: cognitoConfig.oauth.scope ?? [
                        'phone',
                        'email',
                        'profile',
                        'openid'
                    ],
                    redirectSignIn: [
                        cognitoConfig.oauth.redirectSignIn
                    ],
                    redirectSignOut: [
                        cognitoConfig.oauth.redirectSignOut
                    ],
                    responseType: 'code'
                }
            }
        }
    };
    return {
        Auth: auth
    };
};
const getAuth0ClientSettings = (authConfig)=>{
    if (!authConfig) throw new Error('Auth0 config is required');
    const domain = authConfig.domain || process.env.NEXT_PUBLIC_AUTH0_DOMAIN;
    if (!domain) throw new Error('Auth0 domain is required');
    const clientId = authConfig.clientId || process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID;
    if (!clientId) throw new Error('Auth0 clientId is required');
    const rootDomain = window.location.hostname.split('.').reverse().splice(0, 2).reverse().join('.');
    const orgId = getPurinaOrgId(domain);
    return {
        ...authConfig,
        logLevel: authConfig.logLevel ?? 'info',
        authorizationParams: {
            ...authConfig.authorizationParams,
            scope: authConfig.authorizationParams?.scope ?? 'openid profile email offline_access'
        },
        clientId: clientId,
        domain: domain,
        redirectUri: authConfig.redirectUri,
        shouldSaveIdTokenCookie: authConfig.extraCookies?.includes('idToken') ?? false,
        secret: rootDomain,
        cookieDomain: authConfig.cookieDomain?.includes('purina.com') ? '.purina.com' : authConfig.cookieDomain,
        organization: authConfig.organization ?? orgId
    };
};
export { getAuth0ClientSettings, getAwsSettings };
